import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "p-12" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "mb-4" }, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n        More info requested\n      ")
], -1);
const _hoisted_3 = {
    class: "p-5 my-8 bg-slate-200",
    style: { "border-radius": "20px" }
};
const _hoisted_4 = { class: "bg-white shadow overflow-hidden sm:rounded-lg" };
const _hoisted_5 = { class: "p-8" };
const _hoisted_6 = { class: "divide" };
const _hoisted_7 = { class: "my-4" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", {
    for: "comments",
    class: "block text-sm font-medium text-gray-700"
}, "\n                Type your response below:\n              ", -1);
const _hoisted_9 = { class: "mt-4 sm:mt-0 sm:col-span-2" };
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import httpClient from '@/httpClient';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RespondMoreInfo',
    setup(__props) {
        const store = useStore();
        const router = useRouter();
        const formData = ref({});
        const comment = ref('');
        const docId = computed(() => router.currentRoute.value.params.docId);
        const docOwner = computed(() => router.currentRoute.value.params.requestedBy);
        const fetchDocument = async () => {
            store.dispatch('setIsLoading', true);
            const response = await httpClient.post('/bff/get-document', {
                id: docId.value,
                requestedBy: docOwner.value,
            });
            formData.value = response.data.body?.Item ?? {};
            store.dispatch('setIsLoading', false);
        };
        const actionDoc = async (approve) => {
            store.dispatch('setIsLoading', true);
            await httpClient.post('/bff/action-doc', {
                docOwner: docOwner.value,
                id: docId.value,
                approved: approve,
                stage: formData.value.currentStageName,
                comment: comment.value,
            });
            router.go(-2);
            store.dispatch('setIsLoading', false);
        };
        const handleConfirmUser = () => {
            actionDoc('TRUE');
        };
        onMounted(async () => await fetchDocument());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.H2RComments, (item) => {
                                    return (_openBlock(), _createElementBlock("p", {
                                        key: item.timeStampUTC
                                    }, "\"" + _toDisplayString(item.comment) + "\" - " + _toDisplayString(item.userEmail), 1));
                                }), 128))
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("form", null, [
                                    _hoisted_8,
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_9, [
                                        _withDirectives(_createElementVNode("textarea", {
                                            id: "comments-input",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((comment).value = $event)),
                                            name: "comments",
                                            rows: "3",
                                            class: "shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border border-gray-300 rounded-md"
                                        }, null, 512), [
                                            [_vModelText, comment.value]
                                        ])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", { class: "mt-4 flex justify-end" }, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "ml-2 inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                                    onClick: handleConfirmUser
                                }, "Confirm")
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
